import React, { useState, useEffect } from "react";
import TableContainer from "@mui/material/TableContainer";
import "./MoneyGramTableDynamic.scss";
import BaseCustomerTable from "../BaseCustomerTable/BaseCustomerTable";
import DynamicTable from "../DynamicTable/DynamicTable";
import { AssignDeassignRoles } from "../../util/API/admin";
import { useSelector } from "react-redux";
import {
  Box,
} from "@mui/material";

function createData(name, email, phone, address, country) {
  return { name, email, phone, address, country };
}

export default function MoneyGramTableDynamic({
  userData, //Data from the API
  handleSelectedUser, //Function to handle the selected user
  targetID, //this is for the edit icon to be dynamic
  searchText,
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openAccount, setOpenAccount] = useState(false);
  const [userHeader, setUserHeader] = useState("User");
  const [crmTable, setCrmTable] = useState(null);
  const [roles, setRoles] = useState();

  const requiredConstants = useSelector((state) => state.constants);

  let isAdmin = sessionStorage.getItem("isAdmin");
  console.log("userData------------",userData)

  const rows = userData.map((name) => {
    return createData(
      name.name,
      name.email,
      name.phone,
      name.address,
      name.country
    );
  });

  useEffect(() => {
    if (searchText) {
      setPage(0);
    }
  }, [searchText]);

  //Function to handle the opening of the modal with the user data
  const handleOpen = (user, fullUserData) => {
    handleSelectedUser(user, fullUserData, "settings");
    let firstName = fullUserData.firstName;
    let lastName = fullUserData.lastName;
    let id = fullUserData.id;
    setUserHeader(`${firstName} ${lastName} - ${id}`);
  };

  const pageCount = Math.ceil(rows.length / rowsPerPage);
  const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    async function getTable() {
      let response = await fetch(`/tables/moneyGramTable.json`);
      const tableData = await response.json();
      console.log("tableData------------",tableData)
      setCrmTable(tableData);
      setRowsPerPage(tableData.rowsPerPage);
    }
    getTable();
  }, []);

  const assignDeassign = async (merchantid, roleid) => {
    const response = await AssignDeassignRoles(merchantid, roleid, 0);
    return response;
  };

  const systemRoles = async () => {
    setRoles(requiredConstants.systemRoles);
  };

  useEffect(() => {
    systemRoles();
  }, []);

  const handleButton = async(row) => {
    console.log("handleButton--------------",row);
    handleSelectedUser(row);
  }

  return (
    <Box>
      <TableContainer sx={{ boxShadow: "none" }}>
        {crmTable && (
          <DynamicTable
            tableData={userData}
            tableSource={crmTable}
            handleSetting={handleOpen}
            handleEdit={handleSelectedUser}
            handleButton={handleButton}
            page={page}
            targetID={targetID}
            roles={roles}
            handleDeleteRole={assignDeassign}
            isAdmin={isAdmin}
          />
        )}
        <BaseCustomerTable
          page={page}
          onPageChange={handleChangePage}
          pageNumbers={pageNumbers}
        />
      </TableContainer>
    </Box>
  );
}
